
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.906.942A.46.46 0 009.5.704a.46.46 0 00-.405.238l-2.68 4.98a.458.458 0 01-.33.231L.381 7.09a.454.454 0 00-.359.301.435.435 0 00.109.448l4.047 4.014c.1.1.147.239.126.376l-.845 5.558a.44.44 0 00.183.425.47.47 0 00.473.038l5.181-2.498a.47.47 0 01.408 0l5.181 2.498a.469.469 0 00.473-.038.44.44 0 00.183-.425l-.845-5.558a.436.436 0 01.126-.376L18.87 7.84a.435.435 0 00.109-.448.454.454 0 00-.36-.3l-5.703-.938a.458.458 0 01-.33-.232L9.905.941z"}})])
          )
        }
      }
    